module.exports = __webpack_public_path__ + "static/MADE_Evolve_Sans_Bold_EVO-6a742f73e730526ea9df8058daa22d2a.woff";